import forEach from 'dcode/functions/forEach'
import getPostLink from '@/functions/getPostLink'

export default function getElements (basic) {
  const items = []

  forEach(
    [
      ...basic?.main,
      ...basic?.other
    ],
    section => {
      forEach(section.list, element => {
        items.push({
          text: element?.text,
          tags: element?.tags,
          href: getPostLink(element),
          to: getPostLink(element)
        })
      })
    }
  )

  return items
}
